export const WALMART_SHOP_ID = 625